import React from 'react'
import { GoogleReCaptchaProvider } from 'react-google-recaptcha-v3'

import FormContext, {
  type FormContextType
} from '@/components/form/form-context'
import { config } from '@/internal/config/config'
import { type FormWebsite } from '@/internal/types/form'

import FormSteps from './form-steps'
import { isEmptyRecordIds, isFormGate, isInvalidForm } from './form-utils'

export type FormComponentProps = {
  values: FormWebsite
  title?: string
  subtitle?: string
}

type FormProps = FormComponentProps & FormContextType

const Form: React.FC<FormProps> = ({
  values,
  classes,
  contentSelected,
  title,
  subtitle
}) => {
  const formContextValues = React.useMemo(
    () => ({ classes, contentSelected }),
    [classes, contentSelected]
  )

  if (isInvalidForm(values)) {
    return <></>
  }
  if (isFormGate(values) && isEmptyRecordIds(values)) {
    return <></>
  }

  return (
    <GoogleReCaptchaProvider reCaptchaKey={config.recaptcha.key}>
      <FormContext.Provider value={formContextValues}>
        <FormSteps values={values} title={title} subtitle={subtitle} />
      </FormContext.Provider>
    </GoogleReCaptchaProvider>
  )
}

export default Form
